import $ from 'jquery';
class Events {
    constructor(){
        this.events();
    }

    events() {
        var selectedBursary;
        var selectedEvent;
        var selectedSailor;
        var approveBursary;
        //  Register Listeners only if on page
        $("#event-reg-switch").on("change", this.toggleRegOnOff.bind(this));
        $("#registrations-open").on("click", this.showRegistrations.bind(this));
        $("#registrations-close").on("click", this.hideRegistrations.bind(this));
        $("#bursaries-open").on("click", this.showBursaries.bind(this));
        $("#bursaries-close").on("click", this.hideBursaries.bind(this));
        $('#manual-add-bursary').on("change", this.resetSelect.bind(this));
        $('#manual-add-sailor').on("change", this.resetSelect.bind(this));
        
        //  2025-Oct Add dialog box for manual Bursary
        $('#manually-add-bursary-box').dialog({
            autoOpen: false,
            modal: true,
            show: {
                effect: "fadeIn",
                duration: 500
            },
            hide: {
                effect: "fadeOut",
                duration: 500
            },
            buttons: {
                "Save": function(){
                    selectedBursary = $('#manual-add-bursary');
                    selectedSailor = $('#manual-add-sailor');
                    var valid = validateInputs(selectedBursary, selectedSailor);
                    if (valid){
                        updateServer();
                    }
                },
                Cancel: function(){
                    $(this).dialog('close');
                },
            }
        });
        $('#manually-add-bursary-box').removeClass('d-none');
        $("#manual-bursary-add").on("click", this.openManualBursaryDialog.bind(this));
    }
    openManualBursaryDialog(e){
        $('#manually-add-bursary-box').dialog('open');
    }

    resetSelect(e){
        $('#manual-bursary-err-msg').html("&nbsp;");
        $(e.target).removeClass( "ui-state-error");
    }

    hideRegistrations(e){
        $("#registrations-close").addClass('d-none');
        $("#registrations-open").removeClass('d-none');
        $("#event-reg-switch-box").addClass('d-none');
        $("#event-reg-data").addClass('d-none');
    }
    showRegistrations(e){
        $("#registrations-open").addClass('d-none');
        $("#registrations-close").removeClass('d-none');
        $("#event-reg-switch-box").removeClass('d-none');
        $("#event-reg-data").removeClass('d-none');
        $("#registrations-close").hide();
        $("#event-reg-switch-box").hide();
        $("#event-reg-data").hide();
        $("#registrations-close").fadeIn(500);
        $("#event-reg-switch-box").fadeIn(500);
        $("#event-reg-data").fadeIn(500);
    }
    //  2025-Oct    Show bursary data on event page
    hideBursaries(e){
        $("#bursaries-close").addClass('d-none');
        $("#bursaries-open").removeClass('d-none');
        $("#bursary-data").addClass('d-none');
        $("#manual-bursary-add").addClass('d-none');
    }
   
    showBursaries(e){
        $("#bursaries-open").addClass('d-none');
        $("#bursaries-close").removeClass('d-none');
        $("#bursary-data").removeClass('d-none');
        $("#manual-bursary-add").removeClass('d-none');
        $("#bursaries-close").hide();
        $("#bursaries-close").fadeIn(500);
        $("#bursary-data").fadeIn(500);
    }
    //  2025-Oct    End of show bursary Data
    toggleRegOnOff(e){
        var clubToggle = {
            'EVENT': $('#event-input').val()
        }
        if ($('#event-reg-switch').is(':checked')){
            clubToggle.SWITCH  = "ON";
            $('#reg-status').hide();
            $('#reg-status').text("Registration Open");
            $('#reg-status').fadeIn(500);
        }
        else {
            clubToggle.SWITCH  = "OFF";
            $('#reg-status').hide();
            $('#reg-status').text("Registration Closed");
            $('#reg-status').fadeIn(500);
        }
        $.ajax({
            beforeSend:(xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
            },
            url: dysData.root_url + '/wp-json/dys/v1/openRegistrationByEvent/',
            data: clubToggle,
            type: 'POST',
            success: (response) =>{
                //document.location.reload();
            },
            error: (response) => {
                console.log("Invalid Data Response");
                console.log(response);
            }
        });
    }
}

//  2025-OCT  Allow data Validation for manual bursary fields and allow update of server
function validateInputs(selectedBursary, selectedSailor){
    var valid = true;
    if (selectedBursary !=''){
        if (selectedBursary.val() == '0'){
            valid=false;
            selectedBursary.addClass( "ui-state-error" );
        }
    }
    if (selectedSailor !=''){
        if (selectedSailor.val() == '0'){
            valid=false;
            selectedSailor.addClass( "ui-state-error" );
        }
    }
    return valid;
}

function updateServer(){
        var restData = {
            "BURSARY-ID": $('#manual-add-bursary').val(),
            "EVENT-ID": $('#bursary-event-id').val(),
            'BURSARY-SAILOR': $('#manual-add-sailor option:selected').text(),
            'APPROVED': ($('#manual-bursary-approve').is(':checked')?1:0)
        };
        console.log($('#manual-add-sailor option:selected').text());
        $.ajax({
            beforeSend:(xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
            },
            url: dysData.root_url + '/wp-json/dys/v1/manualBursary/',
            data: restData,
            type: 'POST',
            success: (response) =>{
                if (response=="SUCCESS"){
                    location.replace(location.href);
                    $('#manually-add-bursary-box').dialog('close');
                } else {
                    $('#manual-bursary-err-msg').html("Already Exists");
                    $('#manual-bursary-err-msg').removeClass("d-none");
                }
            },
            error: (response) => {
                console.log("Invalid Data Response");
                console.log(response);
            }
        });
}

//  2025-OCT End of bursary changes

export default Events;